import * as types from "~/store/rebooking/rebookingType";

export const clearState = () => ({
  type: types.CLEAR_STATE
});
export const selectRebooking = rebookingSelected => ({
  type: types.SELECT_REBOOKING,
  rebookingSelected
});
export const getAllRebooking = data => ({
  type: types.GET_ALL_REBOOKING_REQUEST,
  data
});

export const getAllPatientRebooking = data => ({
  type: types.GET_ALL_PATIENT_REBOOKING_REQUEST,
  data
});

export const getRebookingByPatientId = data => ({
  type: types.GET_REBOOKING_BY_PATIENT_ID,
  data
});

export const getAllRebookingFromHistory = data => ({
  type: types.GET_ALL_REBOOKING_FROM_HISTORY,
  data
});
